<template>
    <v-container v-click-outside="{ handler: onClickOutside, include }" fluid class="mx-0 px-0">
        <v-navigation-drawer
            v-model="drawer"
            fixed
            dark
            color="#232323"
            class="sidebar"
            width="240"
        >
            <div v-for="section in visibleSections" :key="section.title" class="sidebar__section">
                <div class="sidebar__section-title">{{ section.title }}</div>
                <v-list nav dense class="py-0">
                    <v-list-item
                        v-for="menuItem in section.items"
                        :key="menuItem.to"
                        :to="menuItem.to"
                        link
                        active-class="sidebar__item--active"
                        class="sidebar__item"
                        @click="setDrawer"
                    >
                        <v-list-item-icon class="mr-3">
                            <v-icon small>{{ menuItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </div>
        </v-navigation-drawer>
    </v-container>
</template>

<script>
    import { menuSections, canSee } from '@/utils/menu'

    export default {
        name: 'Sidebar',
        computed: {
            drawer: {
                get() {
                    return this.$store.getters.getDrawer
                },
                set(value) {
                    return value
                }
            },
            // Filter menu items by roles and drop sections left empty
            visibleSections() {
                const roles = this.$store.getters.getUserRoles
                return menuSections
                    .map(section => ({ ...section, items: section.items.filter(item => canSee(item, roles)) }))
                    .filter(section => section.items.length)
            }
        },
        methods: {
            onClickOutside() {
                this.setDrawer()
            },
            setDrawer() {
                if (this.drawer) {
                    this.$store.dispatch('setDrawer', !this.drawer)
                }
            },
            include() {
                return [document.querySelector('.included')]
            }
        }
    }
</script>

<style scoped>
.container {
    align-self: center;
    height: 100%;
}

/* charcoal like the website menus, the teal of the website marks where you are */
.sidebar {
    padding-top: 59px;
}

.sidebar ::v-deep .v-navigation-drawer__border {
    display: none;
}

.sidebar ::v-deep .v-navigation-drawer__content {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.sidebar ::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
    width: 6px;
}

.sidebar ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
}

.sidebar__section {
    padding: 14px 8px 0;
}

.sidebar__section-title {
    padding: 4px 12px 6px;
    font-family: 'Squada One', Arial, sans-serif;
    font-size: 0.95rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #03e5b7;
}

.sidebar__item {
    border-radius: 6px !important;
    margin-bottom: 2px !important;
    color: rgba(255, 255, 255, 0.78) !important;
}

.sidebar__item .v-icon {
    color: rgba(255, 255, 255, 0.55) !important;
}

.sidebar__item:hover {
    background: rgba(255, 255, 255, 0.06);
}

.sidebar__item--active {
    background: linear-gradient(90deg, rgba(3, 229, 183, 0.22) 0%, rgba(3, 122, 222, 0.08) 100%);
    box-shadow: inset 3px 0 0 #03e5b7;
    color: #fff !important;
    font-weight: 600;
}

.sidebar__item--active::before {
    opacity: 0 !important;
}

.sidebar__item--active .v-icon {
    color: #03e5b7 !important;
}
</style>
